import React, { useEffect, useState } from 'react'
import { Titles } from '../../constant/PageTitle'
import { Avatar, Card, Input, Pagination, Segmented, Space, Spin, } from 'antd'
import '../../style/page.css'
import { LayoutGrid, SearchIcon, } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';

import ModuleAction from '../modules/ModuleAction';
import AddCategory from './AddCategory';
import { categoryTypes } from '../../constant/Constatnt';
import { getCategory, setPagination, setSearchParams } from '../../feature/category/CategorySlice';


function CategoryList() {
    const dispatch = useDispatch()
    const [types, setTypes] = useState("Learning")
    const [value, setValue] = useState("");

    const { categoryList, isLoading, totalPage, limit, current, searchParams } = useSelector((state) => state.categories);

    const handlePagination = (page) => {
        console.log("page", page)
        dispatch(setPagination(page))
    };


    const fetchCategoryList = async () => {
        dispatch(getCategory({ current, limit, searchParams, types }));
    }
    useEffect(() => {
        fetchCategoryList()
    }, [current, searchParams, types])


    useEffect(() => {
        const timer = setTimeout(() => {
            dispatch(setSearchParams(value));
        }, 1000);

        return () => clearTimeout(timer);
    }, [value]);

    function handleSearch(e) {
        setValue(e.target.value);
    }
    return (
        <section>
            <Card>
                <div className="page_title">
                    <p>{Titles.category}</p>
                    <Space>
                        <Input allowClear size='large' suffix={<SearchIcon color='lightGray' size={16} />} placeholder="Search" onChange={handleSearch} variant="filled" />
                        <AddCategory types={types} />
                    </Space>
                </div>
                <div className='cat_types'>
                    <Segmented
                        size='large'
                        
                        options={categoryTypes}
                        onChange={value => {
                            setTypes(value)
                            console.log(value); // string
                        }}
                    />
                </div>
            </Card>
            <div className="page_content">
                {isLoading ? <Spin  fullscreen /> :
                    <div className="show_relation">
                        {categoryList.map((item) => (
                            <>
                                <Card key={item._id} hoverable >
                                    <Space>
                                        <Avatar icon={<LayoutGrid />} style={{ background: "#25B5F8" }} />
                                        <div className='categories'>
                                            <h3>{item.categoryName}</h3>
                                            <p>{item.categoryType}</p>
                                        </div>
                                    </Space>
                                    <div className="options">
                                        <ModuleAction types="category" editData={item} />
                                    </div>
                                </Card>
                            </>
                        ))}
                    </div>
                }
            </div>
            <div className="pagination">
                <Pagination
                    current={current}
                    onChange={handlePagination}
                    total={totalPage ? totalPage * 10 : 0}
                />
            </div>
        </section >
    )
}

export default CategoryList